(() => {
    const actionUrl = '/actions/moldejazz/password/validate';
	const form      = document.querySelector('[data-password-form]');
    const content   = document.querySelector('[data-password-protected]');
	if (!form || !content) {

        return;
    }
    
    const eventId = form.querySelector('input[name="eventId"]').value;
    if (localStorage.getItem(`password-${eventId}`)) {
        content.style.display = 'block';
        form.style.display    = 'none';

        return;
    }

    form.addEventListener('submit', event => {
        event.preventDefault();

        const email = form.querySelector('input[name="email"]').value;
        const gdpr  = form.querySelector('input[name="gdpr"]').checked;

        if (validateEmail(email) && gdpr) {
            const xhr = new XMLHttpRequest();
        
            xhr.onload = () => {
                if (xhr.responseText) {
                    const response = xhr.responseText;

                    if (response === 'Success') {
                        localStorage.setItem(`password-${eventId}`, true);
                        content.style.display = 'block';
                        form.style.display    = 'none';
                    }
                } else {
                    console.error('SERVER ERROR: ' + xhr.statusText);
                }
            }

            console.log('opening xhr');
            xhr.open('get', `${actionUrl}?email=${email}&eventId=${eventId}`);
            xhr.send();
        } else {
            console.error('ERROR: Couldn\'t validate email or missing GDPR');
            
            return false;
        }
    });

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
        return re.test(email);
    }
})();